import { createSelector } from '@reduxjs/toolkit'
import { ImageSizeE } from 'primsell-shared-layer/types'

export const campaignPublicSelector = createSelector(
  (state: AppState) => state.campaignPublic.campaignPublicDetails,
  (value) => value
)

export const isLoadingCampaignPublicSelector = createSelector(
  (state: AppState) => state.campaignPublic.loading,
  (value) => value
)

export const mediumCampaignPublicImageSelector = createSelector(
  (state: AppState) =>
    state.campaignPublic.campaignPublicDetails?.images?.find((image) => image.type === ImageSizeE.MEDIUM)?.path,
  (value) => value
)

export const originalCampaignPublicImageSelector = createSelector(
  (state: AppState) =>
    state.campaignPublic.campaignPublicDetails?.images?.find((image) => image.type === ImageSizeE.ORIGINAL)?.path,
  (value) => value
)
